import React from 'react'

const PaymentSideModal = ({ data }) => {
    return (
        <>
            <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel"></h5>
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="invoice-box">
                    <h1>Payment Details</h1>
                    <p><strong>Appointment Number: </strong> {data?.appointment?.appid}</p>

                    <table className="mt-2">
                        <tr>
                            <th>Description</th>
                            <th>Amount</th>
                        </tr>
                        <tr>
                            <td>Rate</td>
                            <td>${data?.rate}/{data?.rate_unit}</td>
                        </tr>
                        <tr>
                            <td>Estimated Duration</td>
                            <td>{data?.appointment?.duration} minutes</td>
                        </tr>
                        <tr>
                            <td>Minimum Duration</td>
                            <td>{data?.min_duration} {data?.duration_unit}</td>
                        </tr>
                        <tr>
                            <td>Appointment Duration</td>
                            <td>{data?.total_hours} minutes</td>
                        </tr>
                        <tr>
                            <td>Extra Duration</td>
                            <td>{data?.extra_duration} minutes</td>
                        </tr>
                        {data?.extra_mileage > 0 &&
                            <tr>
                                <td>Extra Mileage</td>
                                <td>${data?.extra_mileage}</td>
                            </tr>
                        }
                        <tr className="total">
                            <td >Total Duration</td>
                            <td>{data?.total_hours} minutes</td>
                        </tr>
                        <tr className="total">
                            <td>Total Payment</td>
                            <td>${data?.payment}</td>
                        </tr>
                    </table>

                    <div className="invoice-footer">
                        Thanks for your business!
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentSideModal